module.exports = __webpack_public_path__ + "img/ic_dropdown.06dfdc85.svg";